import { isStatusValid, validatorConsultaSeguimentoOutro } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { createValidator, ErrorObject, required } from 'util/validation'

import { ConsultaSeguimentoPergunta15Model } from './model-consultaSeguimentoPergunta15'
import { hasPergunta15TentaImitarAtLeastTwoSim } from './utils-consultaSeguimentoPergunta15'

export const validatorConsultaSeguimentoPergunta15 = createValidator<ConsultaSeguimentoPergunta15Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_15_HEADER: required,
    OUTRO: validatorConsultaSeguimentoOutro,
  },
  (values: ConsultaSeguimentoPergunta15Model, errors: ErrorObject<ConsultaSeguimentoPergunta15Model>) => {
    if (!hasPergunta15TentaImitarAtLeastTwoSim(values)) {
      errors.PERGUNTA_15_TENTA_IMITAR = createValidator<ConsultaSeguimentoPergunta15Model['PERGUNTA_15_TENTA_IMITAR']>({
        BATE_PALMAS: required,
        COLOCA_DEDOS_NOS_LABIOS: required,
        DA_TCHAU: required,
        FAZ_SOM_ENGRACADO: required,
        MANDA_BEIJO: required,
        POE_LINGUA_PRA_FORA: required,
      })(values?.PERGUNTA_15_TENTA_IMITAR)
    }
    return errors
  }
)
